import env from '@beam-australia/react-env';
import { assets } from '@/shared/config/assets';

export const getAssetName = (assetId: string | undefined): string | undefined => assets[assetId || '']?.name;

export const isRestrictedAsset = (asset: string) => {
  const restrictedAssetIds = env('RESTRICTED_ASSET_IDS');

  if (!restrictedAssetIds) {
    return false;
  }

  return String(restrictedAssetIds).split(',').includes(asset);
};
